<template>
  <div class="orders">
    <router-view v-if="load" />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "AccountOrders",

  provide() {
    return {
      // передаем ниже доступ для выбора менеджеров
      isNoFilterEmployeesProvide: this.isNoFilterEmployees,
    };
  },

  data: () => ({
    load: false,
    isNoFilterEmployees: false,
  }),

  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },

  methods: {
    ...mapActions("account/orders", ["setStatusList"]),

    ...mapActions("account", ["pullEmployees"]),
  },

  created() {
    const hideOrders = this.userInfo.hide_orders;
    const isCurrentPages = this.isPageOrdersSupplier || this.isPageOrdersDealer;
    if (isCurrentPages && hideOrders) {
      this.isNoFilterEmployees = true;

      // если не разрешен фильтр менеджеров, то и в урле не должно их быть
      if (this.$route.query.employees) {
        const query = { ...this.$route.query, employees: undefined };
        this.$router.push({ ...this.$route, query });
      }
    }

    this.togglePreload(true);

    const listFetch = [
      !this.isNoFilterEmployees && this.pullEmployees(),
      this.setStatusList(),
    ].filter(Boolean);

    Promise.all(listFetch).finally(() => (this.load = true));
  },
};
</script>
